import _ from 'lodash';
import {
    SET_LOCALE_TEXTS,
    SET_LOCALE,
    TOGGLE_LANGUAGE_MENU,
    TOGGLE_SIDE_MENU,
    TOGGLE_IMPRINT_POPUP,
    TOGGLE_DATA_PRIVACY_POPUP,
    TOGGLE_BROWSER_DETECT_POPUP,
    SET_DEALER,
    SET_IS_LOADING,
} from '../actions/actionCreators/app';

const initialState = {
    locale: 'de',
    texts: {},
    dealer: '',
    isLanguageMenuOpen: false,
    isSideMenuOpen: false,
    isImprintPopupOpen: false,
    isBrowserDetectPopupOpen: false,
    isDataPrivacyPopupOpen: false,
    isLoading: true,
};

export default function app(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case SET_LOCALE_TEXTS:
            newState.texts = action.texts;
            return newState;
        case SET_LOCALE:
            newState.locale = action.locale;
            return newState;
        case SET_DEALER:
            newState.dealer = action.dealer;
            return newState;
        case TOGGLE_LANGUAGE_MENU:
            newState.isLanguageMenuOpen = !newState.isLanguageMenuOpen;
            return newState;
        case TOGGLE_SIDE_MENU:
            newState.isSideMenuOpen = !newState.isSideMenuOpen;
            return newState;
        case TOGGLE_IMPRINT_POPUP:
            newState.isImprintPopupOpen = !newState.isImprintPopupOpen;
            return newState;
        case TOGGLE_DATA_PRIVACY_POPUP:
            newState.isDataPrivacyPopupOpen = !newState.isDataPrivacyPopupOpen;
            return newState;
        case TOGGLE_BROWSER_DETECT_POPUP:
            newState.isBrowserDetectPopupOpen = !newState.isBrowserDetectPopupOpen;
            return newState;
        case SET_IS_LOADING:
            newState.isLoading = action.isLoading;
            return newState;
        default:
            return state;
    }
}
